import { render } from "./confirmpic.vue?vue&type=template&id=0849a092"
import script from "./confirmpic.vue?vue&type=script&lang=js"
export * from "./confirmpic.vue?vue&type=script&lang=js"

import "./confirmpic.vue?vue&type=style&index=0&id=0849a092&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__